import React from 'react';
import { ScrollView } from 'react-native';
import { IconButton } from 'react-native-paper';

import { PageItemType } from '@src/api/enums/pageItemType';
import Container from '@src/components/Container';
import Cover from '@src/components/Cover';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import { PageItemAPIProduce } from '@src/enums/pageItemAPIProduce';
import useAnimatedHeader from '@src/hooks/useAnimatedHeader';
import useHandleEntityPress from '@src/hooks/useHandleEntityPress';
import useHasImmigration from '@src/hooks/useHasImmigration';

import Books from './Books';
import { Props } from './types';
import useImmigrationHome from './useImmigrationHome';

const Screen: React.FC<Props> = ({ navigation }) => {
  const immigrationHome = useImmigrationHome();
  const handleScroll = useAnimatedHeader();
  const hasImmigration = useHasImmigration();
  const handleMyLibraryPress = React.useCallback(
    () => navigation.navigate('PrimeLibrary'),
    [navigation]
  );
  const handleEntityPress = useHandleEntityPress();
  console.log('immigrationHome', immigrationHome);

  React.useLayoutEffect(() => {
    if (hasImmigration) {
      navigation.setOptions({
        headerRight: () => (
          <IconButton icon="book" onPress={handleMyLibraryPress} />
        ),
      });
    }
  }, [handleMyLibraryPress, hasImmigration, navigation]);

  return (
    <>
      <VisibleStatusBar />
      <Container>
        <ScrollView scrollEventThrottle={16} onScroll={handleScroll}>
          {immigrationHome.map((item, index) => {
            if (item.type === PageItemType.COVER) {
              const data = item.data;
              return (
                <Cover
                  key={index}
                  source={data.cover.source}
                  onPress={handleEntityPress(data)}
                />
              );
            } else if (item.type === PageItemType.API) {
              const data = item.data;

              if (data.produces === PageItemAPIProduce.Immigration) {
                return <Books key={index} data={data} />;
              } else {
                return null;
              }
            } else {
              return null;
            }
          })}
        </ScrollView>
      </Container>
    </>
  );
};

Screen.displayName = 'ImmigrationHome';

export default Screen;
